export default{
    toggleSidebar({ commit }) {
        commit('TOGGLE_SIDEBAR');
      },
    selectModule({ commit }, module) {
        commit('SET_SELECTED_MODULE', module);
    },
}